// ======================================================================
// File Name       : MessageThreadDetailContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { Col, Button } from 'react-bootstrap';
import * as MessageThreadAction from '../../actions/MessageThreadAction';
import { RETURN_MAX_NUM, MODE } from '../../constants/index';
import { MESSAGE_TYPE, MESSAGE_FILTER } from '../../constants/MessageThreadContants';
import { canAccessRoute } from '../../utils/AuthedUtils';
import * as FunctionConstants from '../../constants/FunctionConstants';
import Header from '../../components/Header';
import MessageThreadDetailInfo from '../../components/messageThread/MessageThreadDetailInfo';
import MessageThreadDetailUserList from '../../components/messageThread/MessageThreadDetailUserList';
import * as Path from '../../constants/PathConstants';
import DialogConfirm from '../../components/DialogConfirm';
import * as MessageTemplate from '../../constants/MessageTemplate';
import CustomLink from '../../components/button/CustomLink';

class MessageThreadDetailContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startPosition: 0,
      messageIdAuto: null,
      messageType: null,
      sentReceivedMessageFilter: null,
      canAccess: false,
      sent: false,
      showDeleteModal: false,
    };
    this.getMessageThreadDetail = this.getMessageThreadDetail.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.goBack = this.goBack.bind(this);
    this.deleteMessageThread = this.deleteMessageThread.bind(this);
    this.onDeleteDialogCancel = this.onDeleteDialogCancel.bind(this);
    this.onDeleteDialogOk = this.onDeleteDialogOk.bind(this);
  }

  componentWillMount() {
    const { match } = this.props;
    let messageType = null;
    let sentReceivedMessageFilter = null;
    let canAccess = false;
    let sent = null;
    if (match.path === Path.RECEIVE_MESSAGE_THREAD_DETAIL) {
      messageType = MESSAGE_TYPE.SUB;
      sentReceivedMessageFilter = MESSAGE_FILTER.RECEIVED;
      canAccess = canAccessRoute(FunctionConstants.RECEIVE_MESSAGE_THREAD_DETAIL);
      sent = false;
    } else if (match.path === Path.SENT_MESSAGE_THREAD_DETAIL) {
      messageType = MESSAGE_TYPE.ROUTE;
      sentReceivedMessageFilter = MESSAGE_FILTER.SENT;
      canAccess = canAccessRoute(FunctionConstants.SENT_MESSAGE_THREAD_DETAIL);
      sent = true;
    } else {
      this.props.history.goBack();
      return;
    }
    this.getMessageThreadDetail(
      match.params.id,
      messageType,
      sentReceivedMessageFilter,
      canAccess,
      sent,
    );
  }

  // Step 10.0.0 START
  componentWillUnmount() {
    this.props.dispatch(MessageThreadAction.resetData());
  }
  // Step 10.0.0 END

  getMessageThreadDetail(messageIdAuto, messageType, sentReceivedMessageFilter, canAccess, sent) {
    if (!messageIdAuto) {
      this.props.history.goBack();
      return;
    }
    this.setState(
      {
        messageIdAuto,
        messageType,
        sentReceivedMessageFilter,
        canAccess,
        sent,
      },
      () => {
        const param = {};
        param.messageType = this.state.messageType;
        param.searchInfo = {
          messageList: [messageIdAuto],
          startPosition: 0,
          returnMaxNum: RETURN_MAX_NUM,
          sentReceivedMessageFilter: this.state.sentReceivedMessageFilter,
        };
        this.props.dispatch(MessageThreadAction.getMessageThreadDetail(param));
      },
    );
  }

  goBack() {
    this.props.history.goBack();
  }

  deleteMessageThread() {
    this.setState({
      showDeleteModal: true,
    });
  }

  onDeleteDialogOk() {
    const { messageInfo, rootMessageIdAuto, rootMessageRelationList } = this.props;
    let userSecernIdList = [];
    if (rootMessageRelationList && rootMessageRelationList.length) {
      userSecernIdList = rootMessageRelationList.reduce((acc, cur) => {
        if (cur.rootMessageIdAuto === rootMessageIdAuto && cur.userSecernId) {
          acc.push(cur.userSecernId);
        }
        return acc;
      }, []);
    }
    const param = {
      paramMessageInfo: {
        editType: MODE.DELETE_MODE,
        messageInfo: {
          messageIdAuto: messageInfo.messageIdAuto,
          messageType: this.state.messageType,
        },
      },
      paramRelation: {
        editType: MODE.DELETE_MODE,
        rootMessageInfo: {
          rootMessageIdAuto,
          userList: userSecernIdList,
        },
      },
    };
    this.setState({
      showDeleteModal: false,
    }, () => {
      this.props.dispatch(MessageThreadAction.deleteMessageThread(param)).then((error) => {
        if (!error) {
          this.goBack();
        }
      });
    });
  }

  onDeleteDialogCancel() {
    this.setState({
      showDeleteModal: false,
    });
  }

  getStartEndData(startPosition) {
    const { messageInfo } = this.props;
    const rootMessageIdAuto = messageInfo.rootMessageIdAuto
      ? messageInfo.rootMessageIdAuto
      : messageInfo.messageIdAuto;
    this.setState(
      {
        startPosition,
      },
      () => {
        const searchUserRelationInfo = {
          rootMessageList: [rootMessageIdAuto],
          startPosition,
          returnMaxNum: RETURN_MAX_NUM,
        };
        this.props.dispatch(
          MessageThreadAction.getMessageThreadUserRelation(searchUserRelationInfo),
        );
      },
    );
  }

  render() {
    const {
      messageInfo: { messageIdAuto, messageTitle, messageContent, attachmentFileName, messageOperationFlag },
      messageThreadDetailUserList,
      userListRecordNum,
      rootMessageIdAuto,
    } = this.props;
    return (
      <div>
        <CustomLink
          className="margin-right-7 url-list"
          to={Path.SENT_MESSAGE_LIST}
          text="メッセージスレッド一覧に戻る"
          icon="bi bi-chevron-left"
        />
        <Header name="メッセージスレッドの詳細" />
        <MessageThreadDetailInfo
          messageIdAuto={messageIdAuto}
          messageTitle={messageTitle}
          messageContent={messageContent}
          attachmentFileName={attachmentFileName}
          messageOperationFlag={messageOperationFlag}
        />
        <MessageThreadDetailUserList
          messageThreadDetailUserList={messageThreadDetailUserList}
          userListRecordNum={userListRecordNum}
          startPosition={this.state.startPosition}
          sent={this.state.sent}
          rootMessageIdAuto={rootMessageIdAuto}
          getStartEndData={this.getStartEndData}
        />
        <Col sm={12} className="text-center margin-top-20">
          {this.state.canAccess && (
            <Button
              variant="primary"
              className="btn-96 margin-10"
              onClick={this.deleteMessageThread}
            >
              削除
            </Button>
          )}
        </Col>
        <DialogConfirm
          showModal={this.state.showDeleteModal}
          onCancel={this.onDeleteDialogCancel}
          content={MessageTemplate.MSG_DEL_MESSAGE_THREAD}
          onOK={this.onDeleteDialogOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {
    messageInfo,
    messageThreadDetailUserList,
    groupRelationList,
    groupInfo,
    userListRecordNum,
    rootMessageRelationList,
  } = state.messageThread;
  let rootMessageIdAuto = messageInfo ? messageInfo.messageIdAuto : null;
  if (messageInfo && messageInfo.rootMessageIdAuto) {
    rootMessageIdAuto = messageInfo.rootMessageIdAuto;
  }
  return {
    messageInfo,
    rootMessageRelationList,
    rootMessageIdAuto,
    messageThreadDetailUserList,
    groupRelationList,
    groupInfo,
    userListRecordNum,
  };
};

export default connect(mapStateToProps)(MessageThreadDetailContainer);
